<template>
  <div id="wrapper" class="page">
    <employee-side-bar
      v-if="index != 0"
      v-on:changeIndexChild="changeIndex"
      :item="item"
      :index="index"
    ></employee-side-bar>
    <div id="content-wrapper" class="page">
      <div id="employee_upd_fluid" class="container-fluid">
        <div>
          <div class="mb-4">
            <a href="#" @click.prevent="goBack">
              <i class="fas fa-arrow-left mr-2"></i>
              <span v-if="item != null">{{ item.hovaten }}</span>
            </a>
          </div>
          <b-card class="mt-4">
            <thong-tin-chung
              v-if="index == 1"
              ref="ttchung_details"
              :linemanagers="linemanagers"
              :nolinemanager="nolinemanager"
              :dantocs="dantocsUsed"
              :tongiaos="tongiaosUsed"
              :quoctichs="quoctichsUsed"
              :tinhtranghosos="tinhtranghososUsed"
              :departments="departments"
              :banks="banks"
              @openModal="openModal"
              :item="item"
              :vitricongviecs="vitricongviecsUsed"
              :quanhes="quanhesUsed"
              @update="updateItem"
            ></thong-tin-chung>
            <!-- <thong-tin-lien-he v-if="index == 2" ref="ttlienhe_details"
              :quoctichs="quoctichsUsed" :quanhes="quanhesUsed" @openModal="openModal" :item="item"></thong-tin-lien-he> -->
            <!-- <gia-dinh v-if="index == 3" :quoctichs="quoctichsUsed" :quanhes="quanhesUsed" @openModal="openModal" :item="item"/> -->
            <hop-dong-lao-dong
              v-if="index == 4"
              :item="item"
              :departments="departments"
              :department_all="department_all"
              :hinhthucnhanluongs="hinhthucnhanluongsUsed"
              :loaihopdongs="loaihopdongsUsed"
              :hinhthuclamviecs="hinhthuclamviecsUsed"
              :vitricongviecs="vitricongviecsUsed"
              :phucaps="phucapsUsed"
              @openModal="openModal"
            />
            <qua-trinh-cong-tac
              v-if="index == 5"
              :item="item"
              :departments="departments"
            />
            <!-- <phuc-loi v-if="index == 12" :item="item"/> -->
            <tai-san v-if="index == 12" :item="item" />
            <khen-thuong v-if="index == 13" :item="item" />
            <ky-luat v-if="index == 14" :item="item" />
            <qua-trinh-dao-tao v-if="index == 15" :item="item" />
            <bang-cap v-if="index == 16" :item="item" />
            <chung-chi v-if="index == 17" :item="item" />
            <kinh-nghiem-lam-viec v-if="index == 18" :item="item" />
            <employee-skill v-if="index == 19" :item="item" />
            <tiep-nhan v-if="index == 20" :item="item" />
            <thoi-viec v-if="index == 21" :item="item" />
            <cong-tac v-if="index == 23" :item="item" />
            <vai-tro v-if="index == 24" :item="item" />
            <tuyen-dung v-if="index == 25" :item="item" />
            <giay-to-co-thoi-han v-if="index == 26" :item="item" />
            <tai-lieu-dinh-kem v-if="index == 27" :item="item" />
            <danh-gia v-if="index == 29" :item="item" />
            <thong-tin-xe v-if="index == 30" :item="item" />
          </b-card>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
    >
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">
          <i class="fas fa-times mr-2"></i>Đóng
        </b-button>
      </template>
      <button class="btn btn-info mb-2" @click.prevent="openChildModal">
        <i class="fas fa-plus"></i> Thêm
      </button>
      <b-table
        bordered
        head-variant="dark"
        hover
        responsive
        :fields="fields"
        :items="modalItems"
      >
        <template v-slot:cell(pickListValue)="data">
          <input
            type="text"
            class="form-control"
            :value="data.item.pickListValue"
            required
            @change="updateModalItem(data, $event)"
          />
        </template>
        <template v-slot:cell(used)="data">
          <input
            type="checkbox"
            v-model="data.item.used"
            @change.prevent="updateUsedModalItem(data)"
          />
        </template>
        <template v-slot:cell(action)="data">
          <button class="btn btn-danger" @click="deleteItem(data)">
            <i class="fas fa-trash-alt"></i>
          </button>
        </template>
      </b-table>
    </b-modal>
    <b-modal
      v-model="childModalShow"
      @ok="storeModalItem"
      header-bg-variant="info"
      header-text-variant="light"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="info" @click="ok()"
          ><i class="fas fa-save mr-2"></i>Lưu</b-button
        >
        <b-button variant="secondary" @click="cancel()"
          ><i class="fas fa-times mr-2"></i>Đóng</b-button
        >
      </template>
      <b-container>
        <b-row class="mb-4">
          <b-col cols="4">
            <label class="mr-2">Tên</label>
            <code>*</code>
          </b-col>
          <b-col cols="8">
            <b-form-input v-model="itemModalName" required></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4"></b-col>
          <b-col cols="8">
            <b-form-checkbox v-model="itemModalUsed"
              >Được sử dụng</b-form-checkbox
            >
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ThongTinChung from "../components/Employee/ThongTinChung";
import ThongTinLienHe from "../components/Employee/ThongTinLienHe";
import EmployeeSideBar from "../components/Employee/EmployeeSideBar";
import GiaDinh from "../components/Employee/GiaDinh";
import BangCap from "../components/Employee/BangCap";
import ChungChi from "../components/Employee/ChungChi";
import KinhNghiemLamViec from "../components/Employee/KinhNghiemLamViec";
import EmployeeSkill from "../components/Employee/EmployeeSkill";
import TiepNhan from "../components/Employee/TiepNhan";
import ThoiViec from "../components/Employee/ThoiViec";
import GiayToCoThoiHan from "../components/Employee/GiayToCoThoiHan";
import PhucLoi from "../components/Employee/PhucLoi";
import TaiSan from "../components/Employee/TaiSan"; //Them tai san
import KhenThuong from "../components/Employee/KhenThuong";
import KyLuat from "../components/Employee/KyLuat";
import QuaTrinhDaoTao from "../components/Employee/QuaTrinhDaoTao";
import CongTac from "../components/Employee/CongTac";
import TuyenDung from "../components/Employee/TuyenDung";
import DanhGia from "../components/Employee/DanhGia";
import TaiLieuDinhKem from "../components/Employee/TaiLieuDinhKem";
import VaiTro from "../components/Employee/VaiTro";
import QuaTrinhCongTac from "../components/Employee/QuaTrinhCongTac";
import HopDongLaoDong from "../components/Employee/HopDongLaoDong";
import ThongTinXe from "../components/Employee/ThongTinXe";

export default {
  name: "Employee",
  data() {
    return {
      index: 0,
      linemanagers: [],
      dantocs: [],
      tongiaos: [],
      quoctichs: [],
      quanhes: [],
      departments: [],
      department_all: [],
      hinhthucnhanluongs: [],
      loaihopdongs: [],
      hinhthuclamviecs: [],
      vitricongviecs: [],
      tinhtranghosos: [],
      banks: [],
      modalShow: false,
      childModalShow: false,
      modalItems: [],
      modalType: null,
      fields: [
        {
          key: "pickListValue",
          label: "Tên",
        },
        {
          key: "used",
          label: "Sử dụng",
          thStyle: { width: "100px !important" },
        },
        // {
        //   key: "action",
        //   label: "",
        //   thStyle: { width: "50px !important" },
        // },
      ],
      itemModalName: null,
      itemModalUsed: true,
      item: null,
      nolinemanager: false,
    };
  },
  components: {
    ThongTinChung,
    //ThongTinLienHe,
    //GiaDinh,
    //PhucLoi,
    EmployeeSideBar,
    BangCap,
    ChungChi,
    KinhNghiemLamViec,
    EmployeeSkill,
    TiepNhan,
    ThoiViec,
    GiayToCoThoiHan,
    KhenThuong,
    KyLuat,
    QuaTrinhDaoTao,
    CongTac,
    TuyenDung,
    DanhGia,
    TaiLieuDinhKem,
    VaiTro,
    QuaTrinhCongTac,
    HopDongLaoDong,
    TaiSan,
    ThongTinXe,
  },
  computed: {
    dantocsUsed() {
      const null_value = {
        id: null,
        pickListValue: "",
      };
      let result = this.dantocs.filter((x) => x.used == true);
      result.unshift(null_value);
      return result;
    },
    tongiaosUsed() {
      const null_value = {
        id: null,
        pickListValue: "",
      };
      let result = this.tongiaos.filter((x) => x.used == true);
      result.unshift(null_value);
      return result;
    },
    quoctichsUsed() {
      const null_value = {
        id: null,
        pickListValue: "",
      };
      let result = this.quoctichs.filter((x) => x.used == true);
      result.unshift(null_value);
      return result;
    },
    quanhesUsed() {
      const null_value = {
        id: null,
        pickListValue: "",
      };
      let result = this.quanhes.filter((x) => x.used == true);
      result.unshift(null_value);
      return result;
    },
    vitricongviecsUsed() {
      let result = this.vitricongviecs.filter((x) => x.used == true);
      return result;
    },
    hinhthuclamviecsUsed() {
      let result = this.hinhthuclamviecs.filter((x) => x.used == true);
      return result;
    },
    loaihopdongsUsed() {
      let result = this.loaihopdongs.filter((x) => x.used == true);
      return result;
    },
    hinhthucnhanluongsUsed() {
      let result = this.hinhthucnhanluongs.filter((x) => x.used == true);
      return result;
    },
    phucapsUsed() {
      let result = this.phucaps.filter((x) => x.used == true);
      return result;
    },
    tinhtranghososUsed() {
      let result = this.tinhtranghosos.filter((x) => x.used == true);
      return result;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get(
          "/api/picklist?q=dantoc|tongiao|quoctich|quanhe|hinhthucnhanluong|loaihopdong|hinhthuclamviec|vitricongviec|phucap|tinhtranghoso"
        ),
        axios.get("/api/department"),
        axios.get(`/api/employee/${to.params.slug}`),
        axios.get("/api/department/all"),
        axios.get("/api/bank"),
        axios.get("/api/employee/getlinemanager"),
      ])
      .then(
        axios.spread(
          (picklist, department, item, department_all, bank, linemanager) => {
            next((vm) =>
              vm.initData(
                picklist.data,
                department.data,
                item.data,
                department_all.data,
                bank.data,
                linemanager.data,
                from.matched[0]
              )
            );
          }
        )
      );
  },
  methods: {
    initData(
      picklists,
      departments,
      item,
      department_all,
      banks,
      linemanagers,
      fromMatched
    ) {
      this.dantocs = picklists.filter((x) => x.pickListType == "dantoc");
      this.tongiaos = picklists.filter((x) => x.pickListType == "tongiao");
      this.quoctichs = picklists.filter((x) => x.pickListType == "quoctich");
      this.quanhes = picklists.filter((x) => x.pickListType == "quanhe");
      this.dantocs = picklists.filter((x) => x.pickListType == "dantoc");
      this.hinhthucnhanluongs = picklists.filter(
        (x) => x.pickListType == "hinhthucnhanluong"
      );
      this.loaihopdongs = picklists.filter(
        (x) => x.pickListType == "loaihopdong"
      );
      this.hinhthuclamviecs = picklists.filter(
        (x) => x.pickListType == "hinhthuclamviec"
      );
      this.vitricongviecs = picklists.filter(
        (x) => x.pickListType == "vitricongviec"
      );
      this.phucaps = picklists.filter((x) => x.pickListType == "phucap");
      this.tinhtranghosos = picklists.filter(
        (x) => x.pickListType == "tinhtranghoso"
      );
      this.departments = departments;
      this.linemanagers = linemanagers;
      this.department_all = department_all;
      this.banks = banks;
      this.item = item.employee;
      this.nolinemanager = item.noLiMngr;
      if (fromMatched)
        if (["/edit_asset/:slug"].includes(fromMatched["path"]))
          this.index = 12;
        else this.index = 1;
      else this.index = 1;
    },
    goBack() {
      // this.$router.go(-1);
      this.$router.push("/hr_record");
    },
    changeIndex(data) {
      this.index = data;
    },
    openModal(modalType) {
      this.modalType = modalType;
      this.modalShow = true;
      switch (modalType) {
        case "dantoc":
          this.modalItems = this.dantocs;
          break;
        case "quoctich":
          this.modalItems = this.quoctichs;
          break;
        case "tongiao":
          this.modalItems = this.tongiaos;
          break;
        case "quanhe":
          this.modalItems = this.quanhes;
          break;
        case "vitricongviec":
          this.modalItems = this.vitricongviecs;
          break;
      }
    },
    openChildModal() {
      this.itemModalName = null;
      this.itemModalUsed = true;
      this.childModalShow = true;
    },
    updateModalItem(data, event) {
      var new_item_name = event.target.value;
      if (!(new_item_name && new_item_name.length)) {
        this.$toast.error("Vui lòng nhập tên !", "Lỗi", { timeout: 3000 });
        event.target.value = data.item.pickListValue;
      } else {
        var isItemExist = this.modalItems.filter(
          (item) =>
            item.pickListValue.toLowerCase() === new_item_name.toLowerCase() &&
            item.id != data.item.id
        );
        if (isItemExist.length > 0) {
          this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
          event.target.value = data.item.pickListValue;
        } else {
          axios
            .put("/api/picklist", {
              id: data.item.id,
              name: new_item_name,
            })
            .then((res) => {
              this.$toast.success("Cập nhật thành công !", "Thành công", {
                timeout: 3000,
              });
              this.modalItems[data.index].pickListValue = new_item_name;
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              event.target.value = data.item.name;
            });
        }
      }
    },
    updateUsedModalItem(data) {
      axios
        .put("/api/picklist/used", {
          id: data.item.id,
          used: data.item.used,
        })
        .then((res) => {
          this.$toast.success("Cập nhật thành công !", "Thành công", {
            timeout: 3000,
          });
          this.modalItems[data.index].used = data.item.used;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          event.target.value = data.item.name;
        });
    },
    storeModalItem(bvModalEvt) {
      if (!(this.itemModalName && this.itemModalName.length)) {
        this.$toast.error("Vui lòng nhập tên !", "Lỗi", { timeout: 3000 });
        bvModalEvt.preventDefault();
      } else {
        var isItemExist = this.modalItems.filter(
          (item) =>
            item.pickListValue.toLowerCase() ===
            this.itemModalName.toLowerCase()
        );
        if (isItemExist.length > 0) {
          this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
          bvModalEvt.preventDefault();
        } else {
          axios
            .post("/api/picklist", {
              picklisttype: this.modalType,
              picklistvalue: this.itemModalName,
              sortorder: 99,
              used: this.itemModalUsed,
            })
            .then((res) => {
              this.modalItems.push(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        }
      }
    },
    updateItem(data) {
      this.item = JSON.parse(JSON.stringify(data));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style>
#employee_upd_fluid .multiselect--disabled .multiselect__tags {
  background: #e9ecef;
}
#employee_upd_fluid div.multiselect--disabled {
  opacity: 1;
}
</style>
